// extracted by mini-css-extract-plugin
export default {"root":"oh6add","container":"G8IKsC","divider":"zXOtci"};